// extracted by mini-css-extract-plugin
export default {"container":"Group_container__4+GOY","movies":"Group_movies__DOq56","footer":"Group_footer__Jy-zq","list":"Group_list__a8slQ"};